@use '@pes-ui/styles/src/mixins.scss';

.app-playground__range-title {
  font-weight: normal;

  @include mixins.for-tablet-and-down {
    font-size: 18px;
    line-height: 25px;
  }

  @include mixins.for-desktop-only {
    font-size: 22px;
    line-height: 30px;
  }
}
